import { IMovimientoBeca, MovimientoBeca } from '@/shared/model/seguimiento/administrativo/movimiento-beca.model';
import { Beca, IBeca } from '@/shared/model/seguimiento/beca.model';
import { IVerificacion, Verificacion } from '@/shared/model/seguimiento/verificacion/verificacion.model';
import * as personaUtils from '@/shared/util/format-util';
import resolveEstadoBecaVariant from '@/shared/estados/estados-beca.util';
import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';
export interface IDetalleVerificacion {
  beca?: Beca | null;
  activo?: boolean | null;
  movimientoBeca?: MovimientoBeca | null;
  verificacion?: Verificacion | null;
  nombreCompleto?: string | null;
  estadoActual?: EstadoBeca | null;
  checked?: boolean | false;
}

export class DetalleVerificacion implements IDetalleVerificacion {
  constructor(
    public beca?: Beca | null,
    public activo?: boolean | null,
    public movimientoBeca?: MovimientoBeca | null,
    public verificacion?: Verificacion | null,
    public nombreCompleto?: string | null,
    public estadoActual?: EstadoBeca | null,
    public checked?: boolean | false
  ) {}

  static fromObject(data: IDetalleVerificacion): DetalleVerificacion {
    const transformations = {
      beca: (beca: IBeca) => Beca.fromObject(beca),
      movimientoBeca: (movimientoBeca: IMovimientoBeca) => MovimientoBeca.fromObject(movimientoBeca),
      verificacion: (verificacion: IVerificacion) => Verificacion.fromObject(verificacion),
    };

    const detalleverificacion = new DetalleVerificacion();
    for (const [key, value] of Object.entries(data)) {
      const transform = transformations[key as keyof IDetalleVerificacion];
      detalleverificacion[key] = transform ? transform(value) : value;
    }
    detalleverificacion.estadoActual = detalleverificacion.beca.estadoActual;
    detalleverificacion.nombreCompleto = personaUtils.fullName(detalleverificacion.beca.becario);
    detalleverificacion['variant'] = resolveEstadoBecaVariant(detalleverificacion.beca.estadoActual);

    return detalleverificacion;
  }
}
